import { ErrorState, Logo } from "@getsoren/design-system";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

interface ErrorFallbackProps {
  fullPage?: boolean;
}

/**
 * App labels are passed explicitly: the DS ErrorState only carries en/fr defaults, the app
 * translates all seven languages. The supplier brand replaces the default mark.
 */
const ErrorFallback = ({ fullPage }: ErrorFallbackProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ErrorState
      fullPage={fullPage}
      logo={<Logo variant="supplier" />}
      title={t("oups")}
      description={t("anErrorOccurred")}
      actionLabel={t("reload")}
      onReload={() => navigate(0)}
    />
  );
};

export default ErrorFallback;
